import { render, staticRenderFns } from "./NHelpPopover.vue?vue&type=template&id=64938b84&scoped=true"
import script from "./NHelpPopover.vue?vue&type=script&lang=js"
export * from "./NHelpPopover.vue?vue&type=script&lang=js"
import style0 from "./NHelpPopover.vue?vue&type=style&index=0&id=64938b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64938b84",
  null
  
)

export default component.exports